import AbstractObservable from './AbstractObservable'

export interface IPianoRollState {
  tickWidthPx: number
  x: number
  top: number
  left: number
  width: number
  height: number
}

const initialState: IPianoRollState = {
  tickWidthPx: 1,
  x: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
}

class PianoRollStateManager extends AbstractObservable<IPianoRollState> {
  constructor(initial: IPianoRollState = initialState) {
    super(initial)
  }

  protected override notifySubscribers(): void {
    requestAnimationFrame(super.notifySubscribers.bind(this))
  }
}

export default new PianoRollStateManager()
